<template>
    <div>
        <div class="calendar">
            <FullCalendar :plugins="calendarPlugins" :all-day-slot="false" :header="{ // 头部样式
                left: 'today',
                right:' '
            }" :button-text="{ //头部按钮样式
                today: '今天'
            }" :slot-event-overlap="false" :events="event" columnHeaderFormat="ddd" :first-day="nowDay"
                :business-hours="businessHours" :select-allow="handlerAllow" :select-mirror="true" selectable="true"
                min-time="00:00:00" max-time="24:00:00" slot-duration="01:00:00" slot-label-format="HH:mm"
                default-view="timeGridWeek" locale="zh-cn" @eventClick="handleEventClick" @eventDrop="handDrop"
                :eventConstraint="businessHours" @select="handleSelect" aspectRatio="1.5" :editable="true"
                :eventDurationEditable="false" :resourceIds="businessHours" :selectConstraint="businessHours"
                :selectOverlap="false" />
        </div>
    </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import momentPlugin from '@fullcalendar/moment'
import '@fullcalendar/core/locales/zh-cn'
import timeGridPlulgin from '@fullcalendar/timegrid'


export default {
    components: {
        FullCalendar
    },
    data () {
        return {
            calendarPlugins: [dayGridPlugin, timeGridPlulgin, momentPlugin, interactionPlugin],
            event: [
                // {
                //     start: '2019-11-20 14:00:00',
                //     end: '2019-11-20 15:00:00',

                // },
                // {
                //     start: '2019-11-22 12:00:00',
                //     end: '2019-11-22 13:00:00'
                // }
            ],
            data: [
                [15], //周日 0
                [6, "8,12"], //周一 1
                ["10,17", 20], //周二 2
                [], //周三 3
                ["9,15"],//周四 4
                [],//周五 5
                ["15,24"],//周六 6
            ],
            arr: [],
            businessHours: []
        }
    },
    computed: {
        nowDay () { //使得日历是当前时间的后七天
            return new Date().getDay()
        }
    },
    created () {
        this.init()
    },
    methods: {
        handSelectOverlap () {
            return false
        },
        formatTime (t) {
            let a = new Date(t).toJSON()
            let b = new Date(+new Date(a) + 8 * 3600 * 1000)
            let c = b.toISOString()
            let d = c.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
            return d
        },
        transform (val, k) {
            if (typeof (val) == 'string') {
                let a = val.split(",")
                let b = {
                    startTime: `${a[0]}:00`,
                    endTime: `${a[1]}:00`,
                    daysOfWeek: [k]
                }
                this.arr.push(b)
            } else if (typeof (val) == 'number') {
                let c = {
                    startTime: `${val}:00`,
                    endTime: `${val + 1}:00`,
                    daysOfWeek: [k]
                }
                this.arr.push(c)
            }
            this.businessHours = this.arr
        },
        init () {
            this.data.map((item, index) => {
                item.map(j => {
                    this.transform(j, index)
                })
            })
        },
        handlerAllow: info => {
            let a = info.start.getHours()
            let b = info.end.getHours()
            let c = info.start.getDay()
            let d = info.end.getDay()
            const currentDate = new Date()
            const start = info.start
            const end = info.end
            return (start <= end && start >= currentDate && b - a == 1 && c == d)
        },
        handleSelect (info) {
            this.$confirm('是否选择该时间为预约时间?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let a = {
                    start: this.formatTime(info.startStr),
                    end: this.formatTime(info.endStr),
                }
                if (this.event.length < 5) {
                    this.event = this.event.concat(a)
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                } else {
                    this.$message({
                        type: 'warning',
                        message: '一周最多只能预约3次!'
                    });
                }
            }).catch(() => { });
        },
        handleEventClick () {
            // do something
        },
        handDrop () {
          // do something
        }
    }
}

</script>

<style lang="scss" scoped>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
</style>
